module.exports = __webpack_public_path__ + "img/50x-error.b97e357d.png";